<template>
    <div class='table-box'>
        <div>
            <el-form label-width='120px' :model='queryInfo'>
                <el-row>
                    <el-col :span='8'>
                        <el-form-item label='机构：'>
                            <el-select style='width: 100%' v-model='queryInfo.orgId' placeholder='请选择机构' @change="changeOrg">
                                <el-option v-for='item in selectData' :key='item.id' :label='item.statName'
                                    :value='item.id'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span='1'> 
                        <el-form-item label=''>
                      </el-form-item></el-col>
                    <el-col :span='8'>
                        <el-form-item label='开始结束时间：'>
                           <el-date-picker
                            v-model="timeValue"
                            value-format="yyyy-MM-dd" 
                            type="daterange"
                            range-separator="至"
                            @change="changetime"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
       <div class="flex">
         <div class="left">
            <div id="main-chart" style="min-width:450px;width:100%;height:500px"></div>
        </div>
        <div class="left">
            <div id="main-chart1" style="min-width:450px;width:100%;height:500px"></div>
        </div>
       </div>
    </div>
</template>
<script>
import * as echarts from "echarts"
export default {
    inject: ['reload'], //注入
    data() {
        return {
            queryInfo: {
                orgId: '',
                orgId1: '',
            },
            selectData: [],
            taskList: [],
            streetList: [],
            myChart:null,
            myChart1:null,
            timeValue:'',
            startTime:'',
            endTime:''
        }
    },
    created() {
        this.getOrgList()
    },
    mounted() {
        // this.initTwoChart()
        // this.initChart()
    },
    methods: {
        changetime(val){
           this.startTime=val[0]
           this.endTime=val[1]
           this.getTaskList()
        },
        //获取机构信息
        getOrgList() {
            this.$http
                .request({
                    url: '/jjyl/admin/task/state/getServiceStationList',
                    method: 'POST',
                    data: {}
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == 'null') {
                            this.selectData = []
                            return
                        }
                        this.selectData = res.content
                        if (this.selectData.length > 0) {
                            this.queryInfo.orgId = this.selectData[0].id
                        }
                        this.getStreetList()
                        this.getTaskList()
                    }
                })
        },
        //完成率
        changeOrg(val){
          this.queryInfo.orgId=val
          this.getTaskList()
          this.getStreetList()
        //  this.initTwoChart()
          if (this.myChart) {
                this.myChart.dispose();
                this.myChart=null
                this.taskList=[]
            }
            if (this.myChart1) {
                this.myChart1.dispose();
                this.myChart1=null
                this.streetList=[]
            }
         // this.initChart()
        },
       
        //获取机构下乡镇任务完成率
        getTaskList() {
            this.$http
                .request({
                    url: '/jjyl/admin/task/state/getByServiceStationId?serviceStationId=' + this.queryInfo.orgId+'&startTime='+this.startTime+'&endTime='+this.endTime,
                    method: 'get',
                    data: {
                        startTime:this.startTime,
                        endTime:this.endTime
                    }
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == 'null') {
                            this.taskList = []
                            return
                        }
                        this.taskList = res.content
                        this.initTwoChart()
                    }
                })
        },
        //获取机构下乡镇服务对象占比
        getStreetList() {
            this.$http
                .request({
                    url: '/jjyl/admin/task/state/getCustomerRateByServiceStationId?serviceStationId=' + this.queryInfo.orgId,
                    method: 'get',
                    data: {}
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == 'null') {
                            this.streetList = []
                            return
                        }
                        this.streetList = res.content
                        this.initChart()
                    }else{
                        this.streetList=[]
                        this.initChart()
                    }
                })
        },
        initTwoChart() {
            const chartDom = document.getElementById('main-chart');
            if (!chartDom) return;
             
             this.myChart = echarts.init(chartDom);
            // 模拟数据
            let categories = [];
            let completedData = [];
            this.taskList.forEach((item)=>{
                categories.push(item.streetName)
                completedData.push(item.completionRate)
            })
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        let result = params[0].name + '<br/>';
                        params.forEach(param => {
                            result += param.seriesName + ': ' + param.value + '<br/>';
                        });
                        return result;
                    }
                },
                // legend: {
                //     data: ['已完成', '未完成'],
                //     top: 10
                // },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '60px',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    name: '',
                    nameLocation: 'middle',
                    nameGap: 30,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#606266',
                         interval: 0, 
                         rotate:45
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '完成率',
                    axisLine: {
                        show: true,
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eee'
                        }
                    },
                    axisLabel: {
                        color: '#606266'
                    }
                },
                series: [
                    {
                        name: '完成率',
                        type: 'bar',
                        data: completedData,
                        itemStyle: {
                            color: '#409EFF'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            this.myChart.setOption(option,true);
              setTimeout(() => {
                 this.myChart.resize();
            }, 100);
        },
        initChart() {
            const chartDom = document.getElementById('main-chart1');
            if (!chartDom) {
                return
            }
            if (this.myChart1) {
                this.myChart1.dispose();
                this.myChart1=null
            }
             this.myChart1 = echarts.init(chartDom);
            let categories=[]
            let completedData=[]
            this.streetList.forEach((item)=>{
                categories.push(item.streetName)
                completedData.push(item.customerCount)
            })
          //  console.log(this.streetList,categories,completedData,'2')
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                 grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '60px',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    name: '',
                    nameLocation: 'middle',
                    nameGap: 30,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#606266',
                         interval: 0, 
                         rotate:45
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '占比'
                },
                series: [
                    {
                        data: completedData,
                        type: 'bar',
                        itemStyle: {
                            color: '#409EFF'
                        }
                    }
                ]
            };
            this.myChart1.setOption(option,true);
        }
    }
}
</script>
<style scoped>
.table-box {
    .left {
        width: 100%;
        box-sizing: border-box;
         flex: 1; /* 使用flex属性替代width */
        min-width: 0; /* 防止内容溢出 */
    }
}
.flex{
 display: flex;
 /* justify-content: space-between; */
 width:100%;
 .main-chart{
     display: flex;
    align-items: center;
    justify-content: center;
 }
}
</style>